import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SHARED_ENVIRONMENT } from '@k12/environment';
import { DnpeImportResult, DnpeLookupResult, DnpeLookupSuggestion } from '@k12/models';

@Injectable({ providedIn: 'root' })
export class DnpeService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(SHARED_ENVIRONMENT).adminApiUrl;

  importDnpe(file: File): Observable<DnpeImportResult> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<DnpeImportResult>(`${this.apiUrl}/dnpe/import`, formData);
  }

  lookupDnpe(dnpeNumber: string): Observable<DnpeLookupResult> {
    return this.http.get<DnpeLookupResult>(`${this.apiUrl}/dnpe/${encodeURIComponent(dnpeNumber)}`);
  }

  searchDnpe(prefix: string, limit: number = 10): Observable<DnpeLookupSuggestion[]> {
    return this.http.get<DnpeLookupSuggestion[]>(
      `${this.apiUrl}/dnpe/search/suggestions?prefix=${encodeURIComponent(prefix)}&limit=${limit}`
    );
  }
}
